var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-card',{staticClass:"text-center",attrs:{"bg-variant":"light","text-variant":"dark"}},[_c('b-card-body',[_c('apex-chart',{key:_vm.refresh,attrs:{"type":"donut","width":"370","options":_vm.chartOptions,"series":_vm.series}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }